import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { Router } from '@angular/router';
import { AppConfig } from '../../app.config';
import {EventLoggerService} from '@services/event-logger-service';

@Component({
  selector: 'app-regimen-instruction-banner',
  imports: [
    NgClass
  ],
  templateUrl: './regimen-instruction-banner.component.html',
})
export class RegimenInstructionBannerComponent {
  @Input() username: string;
  @Input() regimenClass: string;
  @Input() regimenBackgroundColor: string;
  @Input() regimenKitImage: string;

  constructor(
    private readonly router: Router,
    private readonly appConfig: AppConfig,
    private readonly eventLogger: EventLoggerService
  ) {}

  bannerClick(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'help_see_instructions' }));
    this.router.navigate(['/user'], {
      queryParams: {
        class: this.regimenClass,
        username: this.username,
        tab: this.appConfig.Shared.TABS.REGIMEN,
        instructions: true,
      }
    });
  }

}
